import { Link } from 'react-router-dom';
import './Footer.css';
import logoLong from '../assets/logo-long-black.png';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <img src={logoLong} alt="Lemadoo" className="footer-logo" />
                    <div className="footer-contact">
                        <p>Jl. Haji Kelik, RT 001, RW 006, Srengseng, Kembangan,</p>
                        <p>Kota Adm. Jakarta Barat, DKI Jakarta, 11630</p>
                        <p>+62 8788 3393 211</p>
                        <p>hello@lemadoo.com</p>
                    </div>
                </div>
                <div className="footer-right">
                    <h4>Links</h4>
                    <div className="footer-links">
                        <Link to="/pricing" className="footer-link">
                            Pricing
                        </Link>
                        <Link to="/privacy-policy" className="footer-link">
                            Privacy Policy
                        </Link>
                        <Link to="/terms-and-conditions" className="footer-link">
                            Terms & Conditions
                        </Link>
                        <Link to="/data-processing-agreement" className="footer-link">
                            Data Processing Agreement
                        </Link>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-bottom-left">
                    <p>&copy; {new Date().getFullYear()} Lemadoo. All rights reserved.</p>
                    <div className="footer-security">
                        <i className="fa-solid fa-shield-halved"></i>
                        <span>100% Security Guarantee</span>
                    </div>
                </div>
                <div className="footer-socials">
                    <a
                        href="https://instagram.com/lemadoo"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a
                        href="https://www.facebook.com/profile.php?id=61574704814512"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                    >
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a href="mailto:hello@lemadoo.com" aria-label="Email">
                        <i className="fas fa-envelope"></i>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
